<template>
  <div class="crpg-m-medicalConcierge-health-care-service">
    <h3>{{ medicalTitle }}</h3>
    <table>
      <tbody>
        <tr>
          <th>{{ $t("medicalConcierge.contentText") }}</th>
          <td class="newline">{{ contentText }}</td>
        </tr>
        <tr>
          <th>{{ $t("medicalConcierge.receptionTimeText") }}</th>
          <td class="newline">{{ ReceptionTimeText }}</td>
        </tr>
        <tr>
          <th>{{ $t("medicalConcierge.addressText") }}</th>
          <td class="newline">{{ addressText }}</td>
        </tr>
        <tr>
          <th>{{ $t("medicalConcierge.priceText") }}</th>
          <td class="newline" v-html="priceText"></td>
        </tr>
        <tr>
          <th>{{ $t("medicalConcierge.area") }}</th>
          <td class="newline">{{ area }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    medicalTitle: String,
    contentText: String,
    ReceptionTimeText: String,
    addressText: String,
    priceText: String,
    area: String,
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/molecules/medicalConcierge/healthCareService.scss";
</style>
